import { ReportChecklistData } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import moment from 'moment';

interface Props {
  checklist: ReportChecklistData;
}

export default function ReportChecklistObservations(props: Props) {
  const checklistObservations = props.checklist.checklistObservations;
  return (
    <table
      className={`reportChecklist-requestServices ${
        props.checklist.company?.bosch ? '-bosch' : ''
      }`}
    >
      <thead>
        <tr>
          <th colSpan={1}>Observações</th>
        </tr>
      </thead>

      <tbody>
        {!checklistObservations?.length && (
          <tr>
            <td className="empty" colSpan={1}>
              Não há observações
            </td>
          </tr>
        )}

        {checklistObservations?.map((item) => (
          <tr key={item.id}>
            <td>
              <div style={{ marginBottom: '0.1em' }}>
                <strong>{item.employeeName}</strong> -{' '}
                <small>
                  {moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                </small>
                <div style={{ marginTop: '0.3em' }}>{item.observation}</div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
